import { FC } from 'react'
import { InfoPageWrapper, useInfoPage } from './info-page-wrapper'

const SatelliteData: FC = () => {
  const pageInfo = useInfoPage('satellite-data')

  return (
    <InfoPageWrapper id="satellite-data">
      <ul className="satellite_data">
        <li>
          <p
            dangerouslySetInnerHTML={{
              __html: pageInfo?.description[0] ?? '',
            }}
          ></p>
        </li>
      </ul>
      <ul className="satellite_data">
        <li>
          <p
            dangerouslySetInnerHTML={{
              __html: pageInfo?.description[1] ?? '',
            }}
          ></p>
        </li>
      </ul>
    </InfoPageWrapper>
  )
}

export default SatelliteData
